import SignIn from "./SignIn.js";

import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignUp from "./SignUp";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    if (window.location.hostname.includes("wavedxp.com")) {
      const newUrl = window.location.href.replace(
        "wavedxp.com",
        "smartyrdxp.com"
      );
      window.location.href = newUrl;
      return;
    }
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
